import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ButtonToolbar from '../Button/Toolbar';
import CardPrint from '../Card/CardPrint';
import OrderPrint from '../Card/OrderPrint';
import { connect } from 'react-redux'
import * as entregaActions from '../../actions/entregas';
import { updateEntrega } from '../../actions/pedidos';

const Table = ({ cabecalho, dados, refreshState, refreshList, gridClass, admin, updateEntrega, batchMode, selectedIds, onToggleSelect, onTogglePageSelect, pageEntregaIds, renderDetalhesExtra, batchRowSelectable }) => {

  const [itemActive, setItemActive] = useState();
  const headerBatchRef = useRef(null);

  useEffect(() => {
    if(!batchMode || !headerBatchRef.current) return;
    if(!pageEntregaIds || !pageEntregaIds.length){
      headerBatchRef.current.indeterminate = false;
      headerBatchRef.current.checked = false;
      return;
    }
    const ids = pageEntregaIds;
    let n = 0;
    for(let i = 0; i < ids.length; i++){
      if(selectedIds && selectedIds[ids[i]]) n++;
    }
    headerBatchRef.current.indeterminate = n > 0 && n < ids.length;
    headerBatchRef.current.checked = n === ids.length && ids.length > 0;
  }, [batchMode, selectedIds, pageEntregaIds]);

  const isRowBatchSelectable = (linha) => {
    if(!batchMode || !linha || !linha.entrega) return false;
    if(!batchRowSelectable) return true;
    return !!batchRowSelectable(linha);
  };

  const [printing, setPrinting] = useState({ status: false, type: "" });

  const cancelDelivery = (entrega) => {
		if(!entrega || !admin) return null;
		if(window.confirm("Você realmente deseja cancelar esta entrega?")){
			updateEntrega({ status: "Cancelado pela loja", responsavel: admin.nome }, entrega._id, admin.loja, (error) => {
				refreshList();
        setItemActive();
			});
		}
	}

	const confirmDelivery = (entrega) => {
		if(!entrega || !admin) return null;
		if(window.confirm("Deseja mesmo confirmar esta entrega? Lembre-se que uma notificação será enviada ao comprador!")){
			updateEntrega({ status: "Pedido Entregue", responsavel: admin.nome }, entrega._id, admin.loja, (error) => {
				refreshList();
        setItemActive();
			});
		}
	}

	const pedidoParaPrint = (linha) => {
		const p = linha.entrega && linha.entrega.pedido;
		if(!p) return null;
		if(typeof p === 'object' && p._id) return p;
		return null;
	};

	const pedidoIdParaLink = (linha) => {
		const p = linha.entrega && linha.entrega.pedido;
		if(!p) return null;
		if(typeof p === 'object' && p._id) return p._id;
		if(typeof p === 'string') return p;
		return null;
	};

	/** WhatsApp: só dígitos do telefone do cliente */
	const whatsappHref = (linha) => {
		const tel = linha.entrega && linha.entrega.pedido && linha.entrega.pedido.cliente && linha.entrega.pedido.cliente.telefones && linha.entrega.pedido.cliente.telefones[0];
		if(!tel) return null;
		const d = String(tel).replace(/\D/g, '');
		if(!d) return null;
		return `https://web.whatsapp.com/send?phone=55${d}`;
	};

  return (
    <div className={`Table DynamicTable${batchMode ? ' DynamicTable--batch' : ''}${gridClass ? ` ${gridClass}` : ''}${refreshState ? ' refreshing' : ''}`}>

      <div className="head">
        { batchMode && (
          <div className="head-check" onClick={(e) => e.stopPropagation()}>
            <input
              ref={headerBatchRef}
              type="checkbox"
              disabled={!pageEntregaIds || !pageEntregaIds.length}
              onChange={() => onTogglePageSelect && onTogglePageSelect()}
            />
          </div>
        ) }
        { cabecalho.map((item, idx) => (item !== "Seen" && <div key={idx}>{item}</div> )) }
        { refreshList && (
          <button className="refreshButton" onClick={refreshList}>
            <i className="fas fa-redo"></i>
          </button>
        ) }
      </div>

      <div className="body">
        { dados.map((linha, idx) => (
            <div className={`itemDelivery${itemActive === idx ? ' active' : ''}`} key={idx}>
              <div className={`item${linha["Seen"] === 1 ? ' novo' : ''}`} onClick={() => setItemActive(itemActive === idx ? '' : idx)}>
                { batchMode && linha.entrega && (
                  <div className="cell-check" onClick={(e) => e.stopPropagation()}>
                    <input
                      type="checkbox"
                      disabled={!isRowBatchSelectable(linha)}
                      checked={isRowBatchSelectable(linha) ? !!(selectedIds && selectedIds[String(linha.entrega._id)]) : false}
                      onChange={() => {
                        if(!isRowBatchSelectable(linha)) return;
                        if(onToggleSelect) onToggleSelect(String(linha.entrega._id));
                      }}
                    />
                  </div>
                ) }
                <div>
                  { (linha["Seen"] === 1 && !linha["manual"]) && <span className="newMessage">Novo</span> }
                  { (linha["manual"]) && <span className="newMessage">Manual</span> }
                  { (linha["ID"]) && <span>{linha["ID"]}</span> }
                </div>
                { cabecalho.map((item, index) => item !== "ID" && item !== "Seen" && (
                  <span key={index} className="DynamicTable-cellVal">
                    { linha[item] !== undefined && linha[item] !== null ? linha[item] : '' }
                  </span>
                )) }
              </div>
              { itemActive === idx && (
                renderDetalhesExtra && linha.entrega ? (
                  <div className="content content--deliveryOrder" onClick={(e) => e.stopPropagation()}>
                    <div className={`delivery-order-view order-view active${refreshState ? ' refreshing' : ''}`}>
                      <div className="order-wrapper">
                        <div className="order-content">
                          { renderDetalhesExtra(linha) }
                        </div>

                        { printing.status ? (
                          printing.type === "order" && pedidoParaPrint(linha) ? (
                            <OrderPrint data={pedidoParaPrint(linha)} usuario={admin} onClick={() => setPrinting({ status: false, type: "" })} />
                          ) : (
                            <CardPrint data={linha.entrega} onClick={() => setPrinting({ status: false, type: "" })} />
                          )
                        ) : null }

                        <div className="button-actions" onClick={(e) => e.stopPropagation()}>
                          { whatsappHref(linha) && (
                            <button type="button" className="whatsapp" title="Falar com o cliente" onClick={() => window.open(whatsappHref(linha), '_blank', 'noopener,noreferrer')}>
                              <i className="fab fa-whatsapp"></i>
                            </button>
                          ) }
                          { linha.entrega.shippingMessageSelect && (
                            <button type="button" className="view-card" title="Visualizar cartão" onClick={() => setPrinting({ status: true, type: "delivery" })}>
                              <i className="fa fa-envelope"></i>
                            </button>
                          ) }
                          { pedidoParaPrint(linha) && (
                            <button type="button" className="view-order" title="Imprimir resumo do pedido" onClick={() => setPrinting({ status: true, type: "order" })}>
                              <i className="fa fa-print"></i>
                            </button>
                          ) }
                          { pedidoIdParaLink(linha) && (
                            <Link to={`/pedido/${pedidoIdParaLink(linha)}`} className="delivery-order-viewPedido" title="Abrir pedido">
                              <i className="fas fa-eye"></i>
                            </Link>
                          ) }
                          <button type="button" className="cancel" title="Cancelar entrega" onClick={() => cancelDelivery(linha.entrega)}>
                            <i className="fa fa-times"></i>
                          </button>
                          <button type="button" className="confirm" title="Confirmar entrega" onClick={() => confirmDelivery(linha.entrega)}>
                            <i className="fa fa-check"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                <div className="content">
                  <div className="details">
                    <div className="item_info">
                      <span className="title">Quem envia:</span>
                      <span className="text">{linha.entrega.shippingSender}</span>
                    </div>
                    <div className="item_info">
                      <span className="title">Quem recebe:</span>
                      <span className="text">{linha.entrega.shippingRecipient}</span>
                    </div>
                  </div>

                  <div className="buttonactions">
                    { printing.status ? printing.type === "order" ? (<OrderPrint data={pedidoParaPrint(linha)} usuario={admin} onClick={() => setPrinting({ status: false, type: "" })} />) :
                      <CardPrint data={linha.entrega} onClick={() => setPrinting({ status: false, type: "" })} />
                    : (
                    <>
                      { pedidoIdParaLink(linha) && (
                      <Link to={`/pedido/${pedidoIdParaLink(linha)}`}>
                        <ButtonToolbar type="default max" label="Ver Pedido" icon="fas fa-eye" />
                      </Link>
                      ) }
  
                      <ButtonToolbar type="danger" label="Cancelar Entrega" icon="fas fa-times" onClick={() => cancelDelivery(linha.entrega)} />
                      <ButtonToolbar type="success" label="Confirmar Entrega" icon="fas fa-check" onClick={() => confirmDelivery(linha.entrega)} />
                      <ButtonToolbar type="blue" label="Imprimir Pedido" icon="fa fa-print" onClick={() => setPrinting({ status: true, type: "order" })} />
                      <ButtonToolbar type="orange" label="Imprimir Cartão" icon="fa fa-envelope" onClick={() => setPrinting({ status: true, type: "delivery" })} />
                    </> ) }
                  </div>
                </div>
                )
              )}
            </div>
        )) }
      </div>
    </div>
  )
};

export default connect(null, { ...entregaActions, updateEntrega })(Table);
